import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import { getSampleDraftTreeData, updateBatch, create, deleteRecord } from './../../service';
import { postRecordList } from './../../../filterTree/service';
import { debounce } from 'lodash';
import { AssetModuleTable } from '@/asset/AssetModuleTable';
import { Api as FetchAPI } from '@cui/req';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Table, Empty, Tabs, message, Input } from 'antd';

interface FeatureProductTableProps {
  currentSelectNode: any;
  pageType: string;
}

const FeatureProductTable: ForwardRefExoticComponent<PropsWithoutRef<FeatureProductTableProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    currentSelectNode,
    pageType,
  },
  ref,
) => {
  const [mode, setMode] = useState<string>('view');
  const featureTableRef = useRef<any>();
  const [valueLength, setValueLength] = useState<number>(0);
  const addFeature = async () => {
    const data = {
      bd_material_classification_number: currentSelectNode?.bd_bpart_product_classification_number,
      md_bbom_template_line_id: currentSelectNode?.md_bbom_template_line_id,
      product_code: currentSelectNode?.cpartCode,
      product_type: currentSelectNode?.product_type,
    };
    const res = await create({
      appId: 'master_data',
      modelId: 'md_cpart_product_feature_info',
      data,
    });
    const id = res.data.lastId;
    if (res.success && id) {
      featureTableRef.current?.addEditRecord({
        md_cpart_product_feature_info_id: id,
        ...data,
      });
    }
  };

  const deleteFeature = async (recordData: any) => {
    const res = await deleteRecord({
      appId: 'master_data',
      modelId: 'md_cpart_product_feature_info',
      recordId: recordData?.md_cpart_product_feature_info_id,
    });
    if (res.success) {
      featureTableRef.current?.reload();
    }
  };

  const onMaterialSave = async () => {
    if (!currentSelectNode || mode === 'view') return;
    console.log('onMaterialSave-feature-pro');
    const featureList = featureTableRef.current?.getRowsData();
    const featureMateList = featureList?.map((el: any) => {
      return {
        recordId: el.md_cpart_product_feature_info_id || '0',
        values: {
          md_bbom_template_line_id: el.md_bbom_template_line_id || null,
          bd_feature_type_classification_number: el.bd_feature_type_classification_number || null,
          feature_code: el.feature_code || null,
          product_code: el.product_code || null,
          product_type: el.product_type || null,
          feature_value_code: el.feature_value_code || null,
          comments: el.comments || null,
          bd_material_classification_number: el.bd_material_classification_number || null,
          md_cpart_product_feature_info_id: el.md_cpart_product_feature_info_id || null,
        },
      };
    });
    const featureUpdateList = featureMateList?.filter((el: any) => el.recordId !== '0');
    const params = {
      appId: 'master_data',
      modelId: 'md_cpart_product_feature_info',
      data: featureUpdateList?.map((el: any) => el.values) || [],
    };
    const res = await updateBatch(params);
  };
  useMemo(() => {
    let newMode = 'view';
    if (currentSelectNode?.isProduct && pageType !== 'view') {
      newMode = 'edit';
    }
    setMode(newMode);
  }, [currentSelectNode]);

  return (
    <AssetModuleTable
      API={{ FetchAPI }}
      moduleID={'md_cpart_product_feature_info'}
      namespaceID="master_data"
      columns={[
        { dataIndex: 'bd_feature_type_classification_number' },
        { dataIndex: 'feature_code' },
        { dataIndex: 'feature_value_code' },
        // { dataIndex: 'feature_level_code' },
      ]}
      search={false}
      tableBaseMode={mode}
      hidePagination={pageType !== 'view' ? true : undefined}
      headerTitle={'none'}
      requestParams={{
        filter: `(md_bbom_template_line_id = '${currentSelectNode?.md_bbom_template_line_id}' and product_code = '${currentSelectNode?.cpartCode}')`,
        sort: 'created_at',
        incPageNavigation: true,
        incTotal: true,
        limit: 1000,
        page: 1,
        pageCursor: '',
        version: '0',
      }}
      ref={featureTableRef}
      rowDelable={false}
      optionColumns={mode !== 'view' ? {
        title: '操作',
        valueType: 'option',
        dataIndex: 'options',
        fixed: 'right',
        width: 140,
        align: 'center',
        render: (_text: any, record: any, index: number) => (
          <span>
            <Button
              type="link"
              onClick={() => {
                deleteFeature(record);
              }}
            >
              删除
            </Button>
          </span>
        ),
      } : false}
      toolBarRender={mode === 'edit' && currentSelectNode ? [
        <>
          <Button type="primary" ghost onClick={addFeature}>
            <PlusOutlined /> 新建
          </Button>
        </>,
      ] : undefined}
      onChange={(values: any) => {
        if (values.length === 0) return;
        if (values.length !== valueLength) {
          setValueLength(values.length);
        } else {
          debounce(onMaterialSave, 1000)();
        }
      }}
    />
  );
});

export default FeatureProductTable;
